$(window).scroll(function () {
    $(".js-product-bottom").each(function(){
        var nav = $(this);
        var h = $(this).height();
        var s = $("#product-description").offset().top - window.outerHeight;
        var e = $("#product-description").offset().top + $("#product-description").height() - (h * 2);
        var scroll = $(window).scrollTop();
        if(scroll > s && scroll < e && $(this).hasClass('is-fixed') == false && window.outerWidth<769) {
            nav.css({"bottom": '-100px'});
            nav.css({"position": 'fixed'});
            nav.css({"width": '100%'});
            nav.css({"display": 'block'});
            nav.addClass('is-fixed');
            nav.animate({"bottom": 15},600);
        }
        else if(scroll < s && $(this).hasClass('is-fixed') == true && window.outerWidth<769){
            nav.css({"bottom": '-100px'});
            nav.css({"position": 'fixed'});
            nav.css({"width": '100%'});
            nav.css({"display": 'none'});
            nav.animate({"bottom": -100},600);
            nav.removeClass('is-fixed');
        }
        else if(scroll > e && $(this).hasClass('is-fixed') == true && window.outerWidth<769){
            nav.fadeOut();
            nav.removeClass('is-fixed');
        }
        
    });
});

$(".product-bottom__btn").on("click", function () {
    $("body").css({ top: 0, position: "fixed" });
    $(".product-single__meta > *").appendTo("#cart_modal .modal_inner").hide().fadeIn(300, function () {
      	$("#cart_modal").addClass("open");
    });
});
$(document).on("click", "#cart_modal.open", function () {
	if (!$(event.target).closest(".modal_inner").length) {
        $("body").removeAttr("style");
        $("#cart_modal").removeClass("open").delay(1000).queue(function (next) {
        	$("#cart_modal .modal_inner > *").appendTo(".product-single__meta");
        	next();
      	});
    }
});
$(document).on("click", "#cart_modal.open .btn--cart", function () {
  	$("body").removeAttr("style");
  	$("#cart_modal").removeClass("open").delay(1000).queue(function (next) {
    	$("#cart_modal .modal_inner > *").appendTo(".product-single__meta");
    	next();
  	});
});